import styles from './index.module.css'
import { forwardRef } from 'react'
import { aboutArt, aboutComments, aboutDashboard, aboutWaterDB, aboutWaterShop, webLinks } from '../../constants.tsx'


export const GlassModal = forwardRef<HTMLDivElement>((_, ref) => {
  function openLink(link: string) {
    window.open(link)
  }

  return (
    <div className={styles.glass_container} ref={ref}>
      <div className={styles.glass_items}>
        <div className={styles.glass_cards}>
          <span className={styles.cards_text}>{aboutComments}</span>
          <div className={styles.cards_img_comments} onClick={() => openLink(webLinks.comments)}>
            <span className={styles.card_name_first}>COMMENTS</span>
          </div>
        </div>
      </div>

      <div className={styles.glass_items}>
        <div className={styles.glass_cards}>
          <div className={styles.cards_img_art} onClick={() => openLink(webLinks.art)} >
            <span className={styles.card_name_first}>ART</span>
          </div>
          <span className={styles.cards_text}>{aboutArt}</span>
        </div>
      </div>

      <div className={styles.glass_items}>
        <div className={styles.glass_cards}>
          <span className={styles.cards_text}>{aboutWaterDB}</span>
          <div className={styles.cards_img_waterdb} onClick={() => openLink(webLinks.waterDB)} >
            <span className={styles.card_name_second}>WATER DATABASE</span>
          </div>
        </div>
      </div>

      <div className={styles.glass_items}>
        <div className={styles.glass_cards}>
          <div className={styles.cards_img_dashboard} onClick={() => openLink(webLinks.dashboard)} >
            <span className={styles.card_name_second}>DASHBOARD</span>
          </div>
          <span className={styles.cards_text}>{aboutDashboard}</span>
        </div>
      </div>

      <div className={styles.glass_items}>
        <div className={styles.glass_cards}>
          <span className={styles.cards_text}>{aboutWaterShop}</span>
          <div className={styles.cards_img_watershop} onClick={() => openLink(webLinks.waterShop)} >
            <span className={styles.card_name_third}>WATER SHOP</span>
          </div>
        </div>
      </div>
   
      {/*<div style={{ width: '100%', height: '100%', border: '2px solid black' }}></div>*/}
    </div>
  )
})

